import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { LegacyTypography } from '../../../theme/LegacyTypography.es.js';
import 'react';
import { LegacyColorMap } from '../../../theme/LegacyColorMap.es.js';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Tag } from '../../display/Tag/Tag.es.js';
import { Grid } from '../../layout/Grid/Grid.es.js';
import { Button } from '../../navigation/Button/Button.es.js';
import { Link } from '../../navigation/Link/Link.es.js';
import { boxSizing } from '../../../style-mixins/reset.es.js';
import { Heading } from '../../display/Heading/Heading.es.js';
import { HeadingLevel } from '../../display/Heading/HeadingLevel.es.js';

const Styles = labelStyles("TwoColumnRiver", {
  root: (backgroundColor = "neutral100") => css`
    ${boxSizing};
    background-color: ${Colors[LegacyColorMap[backgroundColor]]};
    padding: 20px;

    @media screen and (min-width: 640px) {
      padding: 40px 30px;
    }

    @media screen and (min-width: 1024px) {
      padding: 60px 20px;
    }
  `,
  container: (isReversed) => css`
    ${boxSizing};
    max-width: 1170px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column-reverse;

    @media screen and (min-width: 1024px) {
      flex-direction: ${isReversed ? "row-reverse" : "row"};
    }
  `,
  content: css`
    ${boxSizing};
    width: 100%;

    @media screen and (min-width: 1024px) {
      max-width: 500px;
      padding-right: 30px;
    }
  `,
  labelContainer: css`
    ${boxSizing};
    margin-bottom: 20px;
  `,
  media: (isReversed) => css`
    ${boxSizing};
    margin-bottom: 20px;
    width: 100%;

    @media screen and (min-width: 1024px) {
      max-width: 500px;
      margin: ${isReversed ? "0 40px 0 0" : "0 0 0 40px"};
    }
  `,
  heading: css`
    ${boxSizing};
    ${LegacyTypography.pageHeader9}
    color: ${Colors.GrayWarm10};
    margin-bottom: 20px;
    @media screen and (min-width: 640px) {
      ${LegacyTypography.pageHeader7}
    }

    @media screen and (min-width: 1024px) {
      ${LegacyTypography.pageHeader5}
    }
  `,
  description: css`
    ${boxSizing};
    ${LegacyTypography.paragraph1Short}
    color: ${Colors.GrayWarm10};
    margin-bottom: 20px;
  `,
  cta: css`
    ${boxSizing};
    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 640px) {
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
  secondaryCta: css`
    ${boxSizing};
    margin-top: 20px;
  `
});
const TwoColumnRiver = ({ backgroundColor = "neutral100", ctaColor = "primary", ctaHref, ctaText, ctaTarget, description, heading, isReversed = false, media, onCtaClick, onCtaKeyDown, onSecondaryCtaClick, onSecondaryCtaKeyDown, secondaryCtaHref, secondaryCtaText, label, labelIcon, labelColor, className }) => {
  const getCtaComponent = () => {
    const sharedProps = {
      children: ctaText,
      href: ctaHref,
      onClick: onCtaClick,
      onKeyDown: onCtaKeyDown,
      target: ctaTarget
    };
    return jsx(Button, Object.assign({}, sharedProps, {
      // "primary-alt" no longer exists as of V8 and is now mapped to "primary"
      color: ctaColor === "primary-alt" ? "primary" : ctaColor
    }));
  };
  return jsx(
    "div",
    { css: Styles.root(backgroundColor), className, "data-zds": true },
    jsx(
      "div",
      { css: Styles.container(isReversed), className: "twoColumnRiver-container", "data-zds": true },
      jsx(
        "div",
        { css: Styles.content, className: "twoColumnRiver-content", "data-zds": true },
        label && jsx(
          "div",
          { css: Styles.labelContainer, className: "twoColumnRiver-labelContainer", "data-zds": true },
          jsx(Tag, { variant: labelColor }, labelIcon ? jsx(
            Grid,
            { alignItems: "center", columns: "auto max-content", gap: 5 },
            jsx(Icon, { name: labelIcon, size: 20 }),
            label
          ) : label)
        ),
        jsx(
          HeadingLevel,
          null,
          jsx(Heading, { css: Styles.heading }, heading)
        ),
        description && jsx("div", { css: Styles.description, className: "twoColumnRiver-description", "data-zds": true }, description),
        ctaText && (ctaHref || onCtaClick) && jsx("div", { css: Styles.cta, className: "twoColumnRiver-cta", "data-zds": true }, getCtaComponent()),
        secondaryCtaText && secondaryCtaHref && jsx(
          "div",
          { css: Styles.secondaryCta, className: "twoColumnRiver-secondaryCta", "data-zds": true },
          jsx(Link, { href: secondaryCtaHref, onClick: onSecondaryCtaClick, onKeyDown: onSecondaryCtaKeyDown, weight: "bold" }, secondaryCtaText)
        )
      ),
      media && jsx("div", { css: Styles.media(isReversed), className: "twoColumnRiver-media", "data-zds": true }, media)
    )
  );
};

export { TwoColumnRiver };
//# sourceMappingURL=TwoColumnRiver.es.js.map
